module.exports = __webpack_public_path__ + "img/img42.e0024bf5.png";